import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  inject
} from '@angular/core';
import { Event, NavigationStart, Router } from '@angular/router';

import { Toast } from './interfaces/toast';
import { ToastService } from './services/toast.service';

declare const chmln: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AppComponent implements OnInit {
  private _cdr = inject(ChangeDetectorRef);
  constructor(
    private ToastService: ToastService,
    private router: Router
  ) {
    const HeadNodeCollection = document.getElementsByTagName('head');
    const HeadNode = HeadNodeCollection[0];
    const ZendeskScriptElement = document.createElement('script');
    Object.assign(ZendeskScriptElement, {
      async: true,
      id: 'ze-snippet',
      src: 'https://static.zdassets.com/ekr/snippet.js?key=becb35d9-df7f-41dd-8bdb-3ef3def759f3'
    });

    ZendeskScriptElement.onload = () => {
      if (
        !/(vendor-registration)|(vendor-signup)/.test(window.location.href) ||
        /(vendor-registration\/vendor-agreement\/completed)/.test(
          window.location.href
        )
      ) {
        const zE = (window as any).zE;
        if (typeof zE === 'function') {
          zE(function () {
            zE.hide();
          });
        }
      }
    };

    HeadNode.appendChild(ZendeskScriptElement);
  }

  title: string = 'vive-app';
  toasts: Toast[] = [];

  ngOnInit() {
    // Display toasts as soon as they are received.
    this.ToastService.getToast().subscribe({
      next: (data: Toast) => {
        this.toasts.push(data);
        this._cdr.markForCheck();
      }
    });

    // Let Chameleon experiences drive in-app navigation through the router
    // instead of a full page reload.
    try {
      chmln.on('app:navigate', (opts: { to: string }) => {
        this.router.navigateByUrl(opts.to);
      });
    } catch (e) {
      console.error('Chameleon app:navigate bridge failed:', e);
    }

    this.router.events.subscribe({
      next: (event: Event) => {
        if (event instanceof NavigationStart) {
          if (
            (!/(vendor-registration)|(vendor-signup)/.test(event.url) ||
              /(vendor-registration\/vendor-agreement\/completed)/.test(
                event.url
              )) &&
            window.$zopim
          ) {
            window.$zopim.livechat.window.hide();
          }
        }
      }
    });
  }
}
